var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import moment from 'moment';
import { StyledTextInput } from '../TextInput';
var ReadOnlyDateInput = function (props) {
    var identifier = props.identifier, attributes = props.attributes, form = props.form, _a = props.type, type = _a === void 0 ? 'text' : _a, onChange = props.onChange, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "form", "type", "onChange", "children", "windowId"]);
    var enabled = attributes.enabled, readOnly = attributes.readOnly, otherAttributes = __rest(attributes, ["enabled", "readOnly"]);
    return (React.createElement(StyledTextInput, __assign({ value: moment().format('DD/MM/YYYY'), type: type, id: identifier }, otherAttributes, restProps, { attributes: attributes, readOnly: true })));
};
export default ReadOnlyDateInput;
//# sourceMappingURL=index.js.map